<h1 class="mb-5">Recycling Options</h1>

<div class="row">
  <div class="col p-0">
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Search for recycling option..." [(ngModel)]="searchTerm" (input)="filterOptions()">
    </div>
  </div>
  <div class="col p-0">
    <a href="/homeAdmin/v2/recyclingOption/create" class="btn btn-primary float-right">Add Recycling Option</a>
  </div>
</div>

<div class="row">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Title</th>
        <th scope="col">Coefficient</th>
        <th scope="col">Percentage</th>
        <th scope="col">Category</th>
        <th scope="col">Countries</th>
        <th scope="col">Description</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let recycling of filteredRecyclingOptions">
        <td scope="row">{{ recycling.title }}</td>
        <td>{{ recycling.coefficient }}</td>
        <td>{{ recycling.percentage }}%</td>
        <td>{{ recycling.category }}</td>
        <td>{{ recycling.countries }}</td>
        <td class="align-middle">
          <div class="description-text" [attr.title]="recycling.description || '—'" data-toggle="tooltip">
            {{ recycling.description || '—' }}
          </div>
        </td>
        <td class="text-nowrap text-right align-middle">
          <a [routerLink]="['/homeAdmin/v2/recyclingOption/edit', recycling.id]" class="btn btn-primary btn-sm">View</a>
          <button (click)="deleteRecyclingOption(recycling.id)" class="btn btn-danger btn-sm ml-2">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
